import styled, { css } from 'styled-components';
import Input from '../input/Input';
import { TransparentButton } from '../transparent-button/TransparentButton';
import ErrorMessage from '../error-message/ErrorMessage';
import { PlaceholderLabel } from '../input/styles';
import Typography from '../typography/Typography';
import Button from '../button/Button';
export const SelectedItemWrapper = styled.div `
  display: flex;
  align-items: center;
`;
export const CustomValueWrapper = styled.div `
  position: relative;
  display: flex;
  flex: 1;
  align-items: ${({ placeholder, textAfterSelection }) => placeholder || textAfterSelection ? 'end' : 'center'};

  height: 100%;
  max-height: 4.2rem;

  background-color: ${({ theme, disabled }) => !disabled ? '' : theme.colors.surface.disabled};

  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : '')};
  opacity: ${({ disabled }) => (disabled ? '0.6' : '')};
  margin-right: 1rem;
`;
export const Placeholder = styled(PlaceholderLabel) `
  height: auto;
  left: ${({ hasIcon }) => (hasIcon ? 5.3 : 0)}rem;
`;
export const Img = styled.img `
  max-height: 4rem;
`;
export const ValueText = styled(Typography) `
  ${({ hasOtherContent }) => hasOtherContent
    ? css `
          max-width: 90%;
          white-space: nowrap;
          overflow: hidden !important;
          text-overflow: ellipsis;
        `
    : null}
`;
export const PercentButton = styled(Button) `
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.x10};
  background-color: ${({ theme }) => theme.colors.surface.default};
  max-width: 9.4rem;
  height: 3.6rem;
  &:hover {
    background-color: ${({ theme }) => theme.colors.surface.tertiary};
  }
`;
export const PercentButtonsWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  padding: 1.6rem;
`;
export const SelectIconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  background-color: ${({ theme }) => theme.colors.text.interactive};
  width: 3.2rem;
  height: 3.2rem;
`;
export const SelectedIconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  width: 3.2rem;
  height: 3.2rem;
  img {
    width: 100%;
  }
`;
export const FlexCenterContainer = styled.div `
  display: flex;
  align-items: center;
  padding-right: 1rem;
`;
export const CustomInputTab = styled.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-top: ${({ showPercentBar }) => (showPercentBar ? '1.6rem' : 0)};
  border-radius: ${({ theme, borderTopFlat, borderBottomFlat }) => `${borderTopFlat ? theme.borderRadius.medium : theme.borderRadius.highM} ${borderTopFlat ? theme.borderRadius.medium : theme.borderRadius.highM} ${borderBottomFlat ? theme.borderRadius.medium : theme.borderRadius.highM} ${borderBottomFlat ? theme.borderRadius.medium : theme.borderRadius.highM}`};
  border: 1px solid
    ${({ theme, hasError, isFocused }) => hasError && isFocused ? theme.colors.borders.critical : 'transparent'};
  background-color: ${({ theme }) => theme.colors.surface.tertiary};
  ${({ theme, isFocused, hasError }) => isFocused && !hasError
    ? css `
          background-color: ${theme.colors.surface.buttonBackground};
          border-color: ${theme.colors.interactive.brandColor};
        `
    : css ``};
  transition: all 0.3s ease;
  min-height: 10.5rem;
  box-shadow: ${({ isFocused, theme }) => isFocused ? theme.shadows.xl : 'none'};
  position: relative;

  &:hover {
    .container {
      background-color: transparent !important;
    }
  }
  ${({ theme, hasError }) => {
    const backgroundColor = theme.colors.surface.hover;
    const borderCrit = theme.colors.borders.critical;
    const borderHov = theme.colors.borders.hover;
    return theme.media.laptop `
    &:hover {
      background-color: ${backgroundColor}
      border: 1px solid ${hasError
        ? borderCrit
        : borderHov}
    }
  `;
}}
`;
export const CustomInput = styled(Input) `
  border: none !important;
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  background: transparent;
  height: 5.8rem;
  .common-input {
    &::placeholder {
      color: ${({ theme }) => theme.colors.borders.default};
    }
  }
  .input-container {
    max-height: 5.8rem;
  }
  & input {
    background: transparent;
    font-size: 2.4rem;
    font-weight: 500;
    line-height: 32px;
    font-family: ${({ theme }) => theme.fonts.primaryBold};
    ${({ isLoading }) => isLoading && 'display: none'}
  }
  &:focus {
    background-color: ${({ theme }) => theme.colors.surface.buttonBackground};
  }

  &:hover {
    background-color: transparent;
  }

  .input-placeholder {
    white-space: nowrap;

    color: ${({ theme }) => theme.colors.text.secondary};
  }
  .container {
    padding: 0 1.8rem;
  }

  ${({ theme }) => theme.media.laptop `
    &:hover {
      border: none;
    }
  `}
`;
export const FlexContainer = styled.div `
  display: flex;
  align-items: center;
  min-width: 10rem;
`;
export const CustomTransparentButton = styled(TransparentButton) `
  margin-right: 1rem;
`;
export const CustomBalanceContainer = styled.div `
  width: max-content;
  margin-top: 0.4rem;
`;
export const CustomSelectContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const CustomErrorMessage = styled(ErrorMessage) `
  margin: 0.5rem 0 0.5rem;
`;
export const CustomCurrencyContainer = styled.div `
  position: relative;

  width: 100%;

  .select-value__wrapper {
    white-space: nowrap;
  }
`;
export const AnimationWrapper = styled.div `
  width: 8.7rem;
  height: 6.7rem;
  position: absolute;
  top: 1.6rem;
  left: -1rem;
`;
export const TabsWrapper = styled.div `
  width: 100%;
  .currency-select {
    background-color: ${({ theme }) => theme.colors.borders.default + '50'};
  }
`;
export const CustomTypography = styled(Typography) `
  padding-top: 0.2rem;
`;
//# sourceMappingURL=styles.js.map